import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';
import type { NostrEvent } from '@nostrify/nostrify';

import { parsePayto, type PaytoEntry } from '@/lib/payto';

/** Fetches the latest kind 10133 payto/payment-targets event for a pubkey. */
export function usePayto(pubkey: string | undefined) {
  const { nostr } = useNostr();

  return useQuery({
    queryKey: ['stashstr', 'payto', pubkey ?? ''],
    queryFn: async (c) => {
      if (!pubkey) throw new Error('No pubkey');
      const results = await nostr.query(
        [{ kinds: [10133], authors: [pubkey], limit: 5 }],
        { signal: c.signal },
      );
      // Latest by created_at wins
      const latest = results
        .filter((e): e is NostrEvent => e.kind === 10133)
        .sort((a, b) => b.created_at - a.created_at)[0];
      const entries: PaytoEntry[] = parsePayto(latest);
      return entries;
    },
    staleTime: 60_000,
    enabled: Boolean(pubkey),
  });
}
